import { defineStore } from 'pinia';
import { SetupStoreId } from '@/enum';
import { reactive, ref } from 'vue';


export const useSearchCacheStore = defineStore(SetupStoreId.SearchCache, () => {

  interface Search {
    [key: string]: string[],
  }
  /** 获取数据缓存查询
   * key：页面name
   * value：from 这些页面跳转时需要获取缓存
   */
  const cacheNameArr: Search = reactive({
    "system_account": ["system_account-add", "system_account-permission"],
    "system_category": ["system_category-add", "system_category-detail"],
    "client_management": ["client_management-add", "client_management-edit"],
    "product_develop": ["product_develop-add", "product_develop-detail", "product_debug-add"],
    "product_device": ["product_device-detail", "product_log"],
    "product_firmware-list": ["product_firmware-task-detail"],
    "product_debug": ["product_debug-add", "product_debug-detail"],
  });

  const isCache = ref(false)
  const cacheParams = reactive({})
  /**
   * 是否需要带上缓存查询项
   * */
  function handleCache(to: any, from: any) {
    isCache.value = cacheNameArr[to] ? cacheNameArr[to].includes(from) : false
  }
  interface Setting {
    [key: string]: string,
  }
  const columnSetting: Setting = reactive({

  })

  return {
    cacheNameArr,
    isCache,
    handleCache,
    cacheParams,
    columnSetting
  };
},
  {
    persist: { key: 'IOT_COLUMN_SETTING', paths: ['columnSetting'], },
  }
);
